

const initialState = {
    products: [],
    orders: [],
    orderId: 0,
    payments: [],
    vat: 0,
    discount: 0,
    accountTypes: [],
    onlinePayments:[],
    vatcal:0,
    discountcal:0,
    cardTypes: [],
    accounts: [],
    paymentTypes: [],
    credits:[],
    repayments:[]
};


function SalesReducer(state = initialState, action) {

    if (action.type === "SALES_PRODUCT_LIST") {
        console.log(action.payload)
        console.log('here')
        var productDetails = {
            ...state,
            products: action.payload
        };
        return productDetails;
    }
    if (action.type === "ACCOUNT_TYPE_DROPDOWN_LIST") {
        var productDetails = {
            ...state,
            accountTypes: action.payload
        };
        return productDetails;
    }
    if (action.type === "CARD_TYPE_DROPDOWN_LIST") {
        var productDetails = {
            ...state,
            cardTypes: action.payload
        };
        return productDetails;
    }
    if (action.type === "ACCOUNT_DROPDOWN_LIST") {
        var productDetails = {
            ...state,
            accounts: action.payload
        };
        return productDetails;
    }

    if (action.type === "CREDIT_PAYMENT") {
        var productDetails = {
            ...state,
            credits: action.payload
        };
        return productDetails;
    }

    
    if (action.type === "PAYMENT_TYPE_DROPDOWN_LIST") {
        var productDetails = {
            ...state,
            paymentTypes: action.payload
        };
        return productDetails;
    }

    

    if (action.type === "PAYMENT_LIST") {
        var productDetails = {
            ...state,
            payments: action.payload
        };
        return productDetails;
    }


    if (action.type === "ONLINE_PAYMENT_LIST") {
        var productDetails = {
            ...state,
            onlinePayments: action.payload
        };
        return productDetails;
    }
    if (action.type === "REPAYMENTS") {
        var productDetails = {
            ...state,
            repayments: action.payload
        };
        return productDetails;
    }
    
    if (action.type === "VAT") {
        var productDetails = {
            ...state,
            vat: action.payload
        };
        return productDetails;
    }
    if (action.type === "VAT_CAL") {
        var productDetails = {
            ...state,
            vatcal: action.payload
        };
        return productDetails;
    }
    if (action.type === "DISCOUNT_CAL") {
        var productDetails = {
            ...state,
            discountcal: action.payload
        };
        return productDetails;
    }
    if (action.type === "DISCOUNT") {
        var productDetails = {
            ...state,
            discount: action.payload
        };
        return productDetails;
    }
    if (action.type === "ORDER_ID") {
        var productDetails = {
            ...state,
            orderId: action.payload
        };
        return productDetails;
    }



    if (action.type === "ORDERS_LIST") {
        var productDetails = {
            ...state,
            orders: action.payload
        };
        return productDetails;
    }

    return state;
}

export default SalesReducer;














